/* eslint-disable react-hooks/rules-of-hooks */

import { FC, useEffect, useMemo, useState } from 'react';
import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../shared/components/popup/popup.abstract';
import { TPopupDefaultActions } from '../../../../../../../../shared/components/popup/services/popup.service';
import { useTranslation } from 'react-i18next';
import { map } from 'rxjs';
import { Button, styled } from '@mui/material';
import { Content } from './content.popup';
import { IOptionsForDefaultCustomerSettings } from '../../customer.tab';
import { Footer } from '../../../../../../../../shared/components/popup/components/footer.component';

export class DefaultSettingsPopup extends Popup<IDefaultSettingsPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;

    this.Component = () => {
      const { t } = useTranslation();
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 1200 },
        }));
      }, []);
      const [popupTitle, setPopupTitle] = useState('');

      useEffect(() => {
        stream
          .actionListener('open')
          .pipe(map(({ values: { title } }) => `${t('settings.default_settings')} | ${title}`))
          .subscribe(setPopupTitle);
      }, []);

      const formId = 'defaultSettingsForm';

      return (
        <SWrapper stream={stream} {...{ popupTitle }}>
          <Content stream={stream} formId={formId} />
          <Footer>
            <Button form={formId} type='submit' variant='contained' sx={{ minWidth: '125px' }}>
              {t('common.save')}
            </Button>
          </Footer>
        </SWrapper>
      );
    };
  }
}

export interface IDefaultSettingsPopup {
  action: 'save' | TPopupDefaultActions;
  values: {
    id: string;
    title: string;
    optionsForDefaultCustomerSettings: IOptionsForDefaultCustomerSettings;
  };
}
